import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";
import { useLogin } from '../../../context/LoginContext';
import { useLocation } from 'react-router-dom';
import apiClient from "../../../api/apiClient";
import { RELEASE_LATEST, GETVISITERCOUNT } from "../../../utils/ApiEndPoint";

import AnimatedDigit from "../AnimatedDigit";

const Footer = () => {
  const { isLoggedIn } = useLogin();
  const location = useLocation();
  const [visitorCount, setVisitorCount] = useState(0);
  const DefaultVisiterCount = 25000;
  useEffect(() => {
    const fetchVisitorCount = async () => {
      try {
        apiClient.get(GETVISITERCOUNT)
          .then(response => {
            setVisitorCount(DefaultVisiterCount + response.data.allTimeVisitors);
          })
          .catch(error => {
            console.error("Error fetching visitor count:", error);
          });
      } catch (error) {
        console.error("Error fetching visitor count:", error);
      }
    }
    fetchVisitorCount();
  }, []);
  const [lastUpdated, setLastUpdated] = useState("03,Feb,2026");

  const indianDateTimeFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
        timeZoneName: "short",
      }),
    []
  );

  useEffect(() => {
    let isActive = true;

    const loadLatestRelease = async () => {
      try {
        const response = await apiClient.get(RELEASE_LATEST);
        const payload = response?.data;
        const deployedAt =
          payload?.deployedAt ||
          payload?.data?.deployedAt ||
          payload?.release?.deployedAt;

        if (!deployedAt) {
          return;
        }

        const parsedDate = new Date(deployedAt);
        if (Number.isNaN(parsedDate.getTime())) {
          return;
        }

        const formatted = indianDateTimeFormatter.format(parsedDate);

        if (isActive) {
          setLastUpdated(formatted);
        }
      } catch (error) {
        // Keep existing fallback date when API fails.
      }
    };

    loadLatestRelease();

    return () => {
      isActive = false;
    };
  }, [indianDateTimeFormatter]);

  return (
    <footer id="footer">
      <Container fluid>
        {!isLoggedIn && (
          <Row>
            <Col lg={12} className="text-center p0">
              <ul className="footer-links">

                <li>
                  <Link to="/" className={location.pathname === "/" ? "active" : ""}>Home</Link>
                </li>
                <li>
                  <Link to="/aboutus" className={location.pathname === "/aboutus" ? "active" : ""}>About Us</Link>
                </li>
                <li>
                  <Link to="/rti" className={location.pathname === "/rti" ? "active" : ""}>RTI</Link>
                </li>
                <li>
                  <Link to="/websitepolicy" className={location.pathname === "/websitepolicy" ? "active" : ""}>Website Policy</Link>
                </li>
                <li>
                  <Link to="/privacypolicy" className={location.pathname === "/privacypolicy" ? "active" : ""}>Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms&conditions" className={location.pathname === "/conditions" ? "active" : ""}>Terms and Conditions</Link>
                </li>
                <li>
                  <Link to="/copyrightpolicy" className={location.pathname === "/copyrightpolicy" ? "active" : ""}>Copyright Policy</Link>
                </li>
                <li>
                  <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""}> Contact Us</Link>
                </li>
              </ul>
            </Col>
          </Row>
        )}

        <Row>
          <Col lg={12} className="footer" style={{ paddingBottom: "0" }}>
            <p className="white mbtm0">
              Join Us On{" "}
              <a
                href="https://www.facebook.com/PMFasalBimaYojana"
                title="Facebook"
                target="_blank"
                style={{ color: "white", textDecoration: "underline" }}
              >
                Facebook
              </a>{" "}
              |{" "}
              <a
                href="https://twitter.com/pmfby"
                title="X-Twitter"
                target="_blank"
                style={{ color: "white", textDecoration: "underline" }}
              >
                X Twitter
              </a>{" "}
              |{" "}
              <a
                href="https://www.instagram.com/pmfasalbimayojana/"
                title="Instagram"
                target="_blank"
                style={{ color: "white", textDecoration: "underline" }}
              >
                {" "}
                Instagram
              </a>{" "}
              |{" "}
              <a
                href="wim"
                // target="_blank"
                title="Web Information Manager"
              >
                Web Information Manager
              </a>
            </p>

            <small>
              &copy; {new Date().getFullYear()} Copyright @ For Department of
              Agriculture and Farmers Welfare, Ministry of Agriculture and
              Farmers Welfare, Government of India. All Rights Reserved.
            </small>
           

           <span className="footer-bottom-link"> 
            <small className="d-block">Last Updated on : {lastUpdated}</small>   <small className="fw-700">
              Total visitor
              <span id="visitorCount">
                {visitorCount ? (
                  String(visitorCount).split("").map((digit, idx) => (
                    <span key={idx} style={{ border: "1px solid #fff", padding: "4px 8px", minWidth: "24px", textAlign: "center", backgroundColor: "rgba(255,255,255,0.1)", color: "#fff" }}>
                      <AnimatedDigit targetDigit={parseInt(digit)} key={idx} />
                    </span>
                  ))
                ) : (
                  "Loading..."
                )}
              </span>
            </small></span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
